<template>
  <!-- 发货 -->
  <div class="wrapper">
    <!-- 商城订单 -->
    <el-form ref="form" :model="formData" label-width="160px">
      <el-form-item label="快递单号" prop="deliveryNo" :rules="rules">
        <el-input
          style="width: 500px"
          v-model="formData.deliveryNo"
          size="small"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="设备串号" prop="deviceSn">
        <el-input
          style="width: 500px"
          v-model="formData.deviceSn"
          size="small"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="商品采购价" prop="costPrice" :rules="rules">
        <el-input-number
          style="width: 150px"
          v-model="formData.costPrice"
          :min="0"
          size="small"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="备注">
        <el-input
          type="textarea"
          style="width: 500px"
          v-model="formData.remark"
          size="small"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="备注图片" prop="deliveryImageList" :rules="rules">
        <FileUpload
          :isMulti="true"
          :name.sync="formData.deliveryImageList"
        ></FileUpload>
      </el-form-item>
      <el-form-item label="">
        <el-button type="" size="small" @click="closePage">取消</el-button>
        <el-button type="primary" size="small" @click="save">提交</el-button>
      </el-form-item>
    </el-form>
    <!-- 门店订单 -->
    <div style="height: 50px"></div>
  </div>
</template>

<script>
import { dict_order_type } from "@/enum/dict/index.js";
import { handleDeliveryAPI } from "./api";
import FileUpload from "@/components/file-upload/index-send.vue";

export default {
  name: "DeliveryExpress",
  components: { FileUpload },
  data() {
    return {
      activeName: "1",
      rules: [{ required: true, message: "该项不能为空", trigger: "blur" }],
      formData: {
        orderNo: this.$route.params.id,
        deliveryCompany: "",
        deliveryNo: "",
        deviceSn: "",
        costPrice: "",
        deliveryImageList: null,
        deliveryImageUrlList: null,
        remark: "",
        lockCode: "",
      },
      dict_order_type,
    };
  },
  watch: {},
  mounted() {},

  methods: {
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          handleDeliveryAPI(this.formData).then(() => {
            this.$message.success("发货成功");
            setTimeout(() => {
              this.closePage();
            }, 1000);
          });
        }
      });
    },
    emitAwindow() {
      if (window.opener) {
        if (window.opener.getBpageList) {
          window.opener.getBpageList();
        } else {
          window.opener.frames[0].getBpageList();
        }
      }
    },
    closePage() {
      this.emitAwindow();
      window.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper /deep/ {
  width: 100%;
}
</style>
<style lang="scss" scoped>
.wrapper /deep/ {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
  }

  .avatar {
    width: 148px;
    height: 148px;
    display: block;
  }

  .goods-sku,
  .baseInfo-2 {
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 60px;
      height: 60px;
      line-height: 60px;
      text-align: center;
    }

    .avatar {
      width: 60px;
      height: 60px;
      display: block;
    }
  }
}
</style>
